import React from 'react';

import { ICardAreasProps } from './interface';
import { getClassTextTheme } from './utils';

export function Card3Content({
  data: { text_1, text_3, text_5, text_theme_1, text_theme_3, text_theme_5 },
}: Omit<ICardAreasProps, 'onClick'>) {
  return (
    <div
      className="vitrine-template2__card--link-card-education"
      data-testid="card-3-content"
    >
      <span
        className={`vitrine-template2__card--text1 ${getClassTextTheme(
          text_theme_1,
        )}`}
      >
        {text_1}
      </span>
      <span
        className={`vitrine-template2__card--text3 ${getClassTextTheme(
          text_theme_3,
        )}`}
      >
        {text_3}
      </span>
      <span
        className={`vitrine-template2__card--text5 ${getClassTextTheme(
          text_theme_5,
        )}`}
      >
        {text_5}
      </span>
    </div>
  );
}
